import { FocusEvent, memo, useCallback } from "react";
import classnames from "classnames";
import { NumberField, NumberFieldProps } from "../NumberField";

import style from "./style.module.scss";

export type FinancialFieldProps = NumberFieldProps;

export const FinancialField = memo<FinancialFieldProps>(
  (
    {
      className,
      onFocus,
      precision = 2,
      placeholder = "XX.XX",
      isClearable = false,
      ...props
    }) => {
    return (
      <NumberField
        className={classnames(className, style.root)}
        onFocus={useCallback((e: FocusEvent<HTMLInputElement>) => {
          onFocus?.(e);
          if (!e.defaultPrevented) {
            const input = e.target;
            input.select();
          }
        }, [ onFocus ])}
        showErrorIcon={false}
        precision={precision}
        placeholder={placeholder}
        isClearable={isClearable}
        {...props}
      />
    );
  },
);

export default FinancialField;
